const userPermission = {
  en: {
    user_permissions: {
      email: "Email",
      view_coding_ui: "View coding UI",
      article_screen_data: "Article screen data",
      article_screen_data_options: {
        article_id: "Article ID",
        headline: "Headline",
        date_created: "Date created",
        date_published: "Date published",
        outlet: "Outlet",
        language: "Language",
        assigned_to: "Assigned to",
        assigned_by: "Assigned by",
        status: "Status",
        due_date: "Due date",
        fav_score: "Favorability score",
        outlet_tier: "Outlet Tier"
      },
      edit_coded_articles: "Edit coded articles",
      edit_coded_articles_options: {
        assigned_only: "Assigned only",
        yes: "Yes",
        no: "No"
      },
      bulk_update: "Bulk update",
      bulk_update_options: {
        assigned_only: "Assigned only",
        yes: "Yes",
        no: "No"
      },
      bulk_delete_articles: "Bulk delete articles",
      bulk_delete_articles_options: {
        assigned_only: "Assigned only",
        yes: "Yes",
        no: "No"
      },
      edit_project_setup: "Edit project setup",
      media_information_changes: "Media information changes",
      view_coder_home: "View coder home",
      view_coder_home_options: {
        rating: "Rating",
        location: "Location",
        payment_rate: "Payment rate",
        qc_score: "QC score"
      },
      view_coder_auto_assign: "View coder auto-filter",
      view_coders_list: "View coders list",
      assign_articles: "Assign articles",
      assign_articles_options: {
        self: "Self",
        yes: "Yes",
        no: "No"
      },
      view_articles_group_notes: "View articles group notes",
      export_articles_group_notes: "Export articles group notes",
      assign_articles_to_group: "Assign articles to group",
      view_qc: "View QC",
      query_engine: "Query engine",
      query_engine_options: {
        limited: "Limited",
        yes: "Yes",
        no: "No"
      },
      allow_refresh_mv: "Allow Refresh MV",
      allow_force_refresh_mv: "Allow Force Refresh MV",
      analysis_aricle_priority_queue: "Allow Analysis article priority queue"
    }
  }
};

module.exports.userPermission = userPermission;